<template>
  <div class="sxChangeIndex">
    <Header title="实习异动申请记录" type="0" route="/homeIndex"></Header>
    <div class="research">
      <span @click="showPop('学年学期', 'xnxq')">
        <i>学年学期：{{ xnxq.mc }}</i>
        &nbsp;&nbsp;
        <b></b>
      </span>
    </div>
    <NOdata
      v-if="(this.list && this.list.length == 0) || list == '[]'"
      title="未查询到实习异动申请记录"
    ></NOdata>
    <div v-else class="list-item">
      <div class="content" v-for="(item, index) in list" :key="index">
        <div class="top">
          <p>{{ item.kcmc }}[{{ item.kch }}]</p>
          <ul>
            <li>实习项目：借记卡金卡项目</li>
            <li>指导老师：{{ item.zdjsxm }}</li>
            <li>实习前状态：{{ item.sxqzt }}</li>
            <li>实习后状态：{{ item.sxhzt }}</li>
            <li>异动原因：{{ item.yy }}</li>
            <li class="fjck" @click="ckPic(item)">附件：{{ item.filename }}</li>
          </ul>
          <span
            :class="
              item.shzt == '通过'
                ? 'ytgClass'
                : item.shzt == '不通过'
                ? 'btgClass'
                : 'shzClass'
            "
            >{{ item.shzt }}</span
          >
        </div>
        <div class="operate" v-if="item.iswfmes != 1 && item.iswfmes != 2">
          <span @click="send(item.id)">送审</span>
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <span>
        <button @click="goItem">申请</button>
      </span>
    </div>
    <van-image-preview v-model="showPic" :images="images"> </van-image-preview>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      shr: {},
      show1: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      showPic: false,
      show: false,
      xnxq: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      columns: {},
      images: [],
      list: [],
      ssid: ""
    };
  },
  methods: {
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "586",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
      this.save();
    },
    async save() {
      const res = await Api.sxydsqsave({
        id: this.ssid,
        userids: this.shr.dm
      });
      if (res.code == "1") {
        this.$toast.success("送审成功");
        setTimeout(() => {
          this.$router.go(0);
        }, 1500);
      } else {
        return;
      }
    },
    async getList() {
      const res = await Api.getsxydsqjllist({
        xnxq: this.xnxq.dm
      });
      this.list = res.data;
    },
    // 放大附件图片
    async ckPic(item) {
      const res = await Api.sxsxfjxz({
        id: item.id,
        lx: "sxyd"
      });
      this.images.push(res);
      this.showPic = true;
    },
    goItem() {
      this.$router.push({
        path: "/sxChange/item",
        query: {
          xnxq: this.xnxq.dm
        }
      });
    },
    // 送审
    send(id) {
      this.ssid = id;
      this.show1 = true;
    },
    // 获取学年学期
    async getXnxq() {
      let xnxqDefaultIndex = 0;
      const res = await Api.getXnxq();

      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (item.isdqxq === "1") {
              this.xnxqDefaultIndex = index;
              this.xnxq = {
                dm: item.xnxq01id,
                mc: item.xqmc
              };
            }
            return {
              value: item.xnxq01id,
              text: item.xqmc
            };
          }),
          defaultIndex: this.xnxqDefaultIndex
        }
      ];
      this.getList();
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
      this.getList();
    }
  },
  created() {
    this.getXnxq();
    this.getShr();
  }
};
</script>
<style lang="less" scoped>
.sxChangeIndex {
  .research {
    z-index: 99;
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #f4f4f4;
    padding: 5% 5% 3% 5%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background-color: #fff;

    span {
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #757da3;
      letter-spacing: 0;
      text-align: right;
      display: inline-flex;
      align-items: center;
      i {
        font-style: normal;
      }
      b {
        display: inline-block;
        border-right: 3px solid transparent;
        border-left: 3px solid transparent;
        border-top: 3px solid #757da3;
      }
    }
  }
  .list-item {
    height: 70vh;
    overflow: auto;
    padding: 70px 20px 0 20px;
    .content {
      background: #f8f8f8;
      border-radius: 5px;
      margin-bottom: 5%;
      .top {
        padding: 20px 20px 10px 20px;
        position: relative;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          margin-bottom: 10px;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 5px;
        }
        .fjck {
          color: royalblue;
        }
        span {
          height: 20px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          letter-spacing: 0;
          position: absolute;
          top: calc(50% - 10px);
          right: 5%;
          font-weight: bolder;
        }
        .shzClass {
          color: #7469f8;
        }
        .btgClass {
          color: #f86969;
        }
        .ytgClass {
          color: #12ddd6;
        }
        .dssClass {
          color: #757da3;
        }
      }
      .operate {
        border-top: 1px solid #dee1e9;
        display: block;
        height: 40px;
        line-height: 40px;
        display: flex;
        width: 100%;
        span {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-size: 15px;
          color: #212f6e;
          letter-spacing: 0;
          text-align: center;
          font-weight: bold;
          cursor: pointer;
          // &:first-child {
          //   border-right: 1px solid #dee1e9;
          // }
        }
      }
    }
  }
  .icon {
    font-size: 12px;
  }
  .bottom-btn {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding: 0 5% 10px 5%;
    background: #fff;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
    // span {
    //   display: inline-flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   button:first-child {
    //     width: 45%;
    //     height: 44px;
    //     background: #ecedfd;
    //     border-radius: 3px;
    //     color: #7469f8;
    //   }
    //   button:last-child {
    //     width: 45%;
    //     height: 44px;
    //     background: #7469f8;
    //     border-radius: 3px;
    //     color: #fff;
    //   }
    //   .single {
    //     width: 100% !important;
    //   }
    // }
  }
  /* 审核人 */
  .close-icon {
    background: url(../../../../../static/img/close.png) no-repeat center;
  }
  .confirm-icon {
    background: url(../../../../../static/img/confirm.png) no-repeat center;
  }
  .pop-title i {
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    padding: 10px;
  }
  .pop-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .person {
    padding: 15px;
  }
  .person button {
    border-radius: 3px;
    padding: 5px 15px;
    margin-right: 12px;
    margin-bottom: 10px;
  }
  .apply-pop .person .per-btn {
    background-color: #ecedfd;
    color: #7469f8;
  }
  .person .cur {
    background-color: #7469f8;
    color: #ecedfd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxChange/index.vue